import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/**
 * @module pokemon-expectation-vs-reality/client
 */

const root = ReactDOM.createRoot(document.getElementById('pokemon-expectation-vs-reality'));
root.render(
    <App />
);
